module.exports = __webpack_public_path__ + "static/Czestochowa-7fdf2d1cb25b18102c49053c705f3ce7.svg";